module Client.Components.Graph.PressureSensor

open Client.Components.Graph.Recharts
open Client.Components.GraphCommon
open Client.Domain.MeasuredValueString
open Feliz.Recharts
open Fulma
open Shared.Dto.MapSensorData
open Shared.Dto.SensorGraphData
open Shared.Infrastructure

type PressureGraphNode = {
    Ticks: double
    Pressure: float
}

let toPressureSensorGraphData (data: GraphPressureDataDto) : PressureGraphNode = {
    Ticks = data.TimeStamp.ToUnixTimeSeconds() |> double
    Pressure = data.Pressure
}

let mapDataToPressure (data: GraphDataDto) =
    match data with
    | Pressure data -> Some data
    | _ -> None

let currentPressureDataBox (data: PressureData) = [
    Level.level [] [
        currentDataLevelItem "Wann?" (DateTime.toDateTimeString data.Date.LocalDateTime)
        currentDataLevelItem "Druck" (pressureToString data.Pressure)
    ]
]

let private createPressureYAxisTicks (data: PressureGraphNode list) =
    let values = data |> List.map (fun item -> item.Pressure)

    let min = List.min values
    let max = List.max values

    AxisTicks.generate true 1. min max

let private yAxisTickFormatter (unit: string) (factor: float) (value: float) = sprintf "%.2f %s" (value / factor) unit

let pressureDataGraphs (graphData: SimpleGraphData<PressureGraphNode>) =
    let xDomain = xAxis.domain (domain.min, domain.max)
    let yDomain = yAxis.domain (domain.min, domain.max)
    let xAxisTickInterval = xAxis.interval.preserveStartEnd

    let yAxisTicks = graphData.Data |> createPressureYAxisTicks

    let pressureYAxisTicks = AxisTicks.createYProperty yAxisTicks

    let dataKey = (fun (p: PressureGraphNode) -> p.Ticks) |> xAxis.dataKey

    let pressureChart =
        Recharts.lineChart [
            lineChart.syncId "syncId1"
            lineChart.data graphData.Data
            lineChart.children [
                Recharts.xAxis [
                    dataKey
                    xAxis.number
                    xAxis.scale.time
                    xAxis.tickFormatter formatTimeTick
                    xDomain
                    xAxisTickInterval
                ]
                Recharts.yAxis [
                    yAxis.number
                    pressureYAxisTicks
                    yAxis.unit " bar"
                    yDomain
                ]
                Recharts.legend []
                Recharts.tooltip [ tooltip.content tooltipContent ]
                Recharts.line [
                    line.dot false
                    line.dataKey (fun p -> p.Pressure)
                    line.name "Druck [bar]"
                    line.stroke "#cc9933"
                ]

                Recharts.cartesianGrid [ cartesianGrid.strokeDasharray [| 3; 3 |] ]
            ]
        ]
        |> fullHeightGraphBox "Verlauf des Druckes"


    [ pressureChart ]

let graphDataToPressureGraphData (data: GraphPressureDataDto list) =
    data |> List.map toPressureSensorGraphData |> (fun list -> { Data = list })